import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useInView } from "framer-motion";
import "./GalleryNationalPromotions.css";

const NATIONAL = [
  {
    id: "np-01",
    title:
      "Curtain Raiser Of Bharat Buildcon 2026 By Shri Piyush Goyal, Hon. Minister Of Commerce & Industry",
    place: "New Delhi",
    img: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "np-02",
    title:
      "Indian Small Scale Paint Association — Export Knowledge Sharing Event",
    place: "Mumbai",
    img: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "np-03",
    title: "Rajkot Hardware Association Meet",
    place: "Rajkot",
    img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "np-04",
    title: "Builders & Developers Round Table",
    place: "Ahmedabad",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "np-05",
    title: "Ceramic Manufacturers Conclave",
    place: "Morbi",
    img: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "np-06",
    title: "Sanitaryware Traders Meet",
    place: "Surat",
    img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=900&auto=format&fit=crop",
  },
];

const NationalCard = ({ n, i, active, setActive }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.35 });

  return (
    <Link
      ref={ref}
      to={`/nationalpromotionsmedia/${n.id}`}
      className={`gnp-card ${isInView ? "gnp-stamped" : ""} ${active === n.id ? "is-active" : ""}`}
      style={{ "--gnp-delay": `${i * 90}ms` }}
      onMouseEnter={() => setActive(n.id)}
      onMouseLeave={() => setActive(null)}
      aria-label={`Open photo album: ${n.title}`}
    >
      <img src={n.img} alt={n.title} loading="lazy" />
      <figcaption>
        <span className="gnp-place">{n.place}</span>
        <p className="gnp-cap-title">{n.title}</p>
      </figcaption>
    </Link>
  );
};

const GalleryNationalPromotions = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="gnp-section" id="nationalpromotions">
      <div className="clean-breadcrumb-wrapper">
        <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="bc-home-link">
            HOME
          </Link>
          <span className="bc-slash">/</span>
          <Link to="/gallery" className="bc-home-link">
            MEDIA &amp; GALLERY
          </Link>
          <span className="bc-slash">/</span>
          <span className="bc-active-page">NATIONAL PROMOTIONS</span>
        </nav>
      </div>

      <div className="gnp-header">
        <div>
          <span className="gnp-eyebrow">Across the country</span>
          <h2 className="gnp-title">National Promotions</h2>
        </div>
        <p className="gnp-subtitle">
          20 states, one movement — the ground events that carried Bharat
          Buildcon to every corner of India.
        </p>
      </div>

      <div className="gnp-grid">
        {NATIONAL.map((n, i) => (
          <NationalCard
            key={n.id}
            n={n}
            i={i}
            active={active}
            setActive={setActive}
          />
        ))}
      </div>
    </section>
  );
};

export default GalleryNationalPromotions;
